export function initGoogleMap() {
  // Check if Google Maps API is loaded
  if (typeof google === 'undefined' || !google.maps) {
    console.error('Google Maps API is not loaded. Map cannot be initialized.');
    return;
  }

  // Check if the map container exists
  const mapContainer = document.getElementById('map');
  if (!mapContainer) {
    console.warn('Map container not found. Google Map will not be initialized.');
    return;
  }

  // Initialize the map
  const mapDataEl = document.getElementById('map-data');
  if (!mapDataEl) {
    console.error('Map data element not found. Google Map cannot be initialized.');
    return;
  }

  // Parse and validate latitude/longitude
  const lat = parseFloat(mapDataEl.getAttribute('data-lat'));
  const lng = parseFloat(mapDataEl.getAttribute('data-lng'));

  // Validate that lat/lng are valid numbers
  if (isNaN(lat) || isNaN(lng)) {
    console.error('Invalid latitude or longitude values. Map cannot be initialized.');
    return;
  }

  // Validate lat/lng are within valid geographic ranges
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
    console.error('Latitude or longitude values out of valid range. Map cannot be initialized.');
    return;
  }

  const mapData = {
    lat: lat,
    lng: lng,
    name: mapDataEl.getAttribute('data-name'),
    location: mapDataEl.getAttribute('data-location'),
    image: mapDataEl.getAttribute('data-image'),
    apiKey: mapDataEl.getAttribute('data-api-key'),
    googleMapsLink: mapDataEl.getAttribute('data-link'),
    zoom: mapDataEl.getAttribute('data-zoom') || 16,
  };

  const map = new google.maps.Map(document.getElementById('map'), {
    center: { lat: mapData.lat, lng: mapData.lng },
    zoom: Number(mapData.zoom),
    scrollwheel: false,
    // styles: mapStyles,
  });

  const infoWindowContent = document.createElement('div');
  infoWindowContent.className = 'enquiry-map-info-card';

  const marker = new google.maps.Marker({
    position: { lat: mapData.lat, lng: mapData.lng },
    map: map,
    icon: {
      url: mapDataEl.getAttribute('data-map-pin'),
      scaledSize: new google.maps.Size(24, 29),
    }
  });

  if (mapData.image) {
    const imageWrapper = document.createElement('div');
    imageWrapper.className = 'info-card-image';

    const imgEl = document.createElement('img');

    imgEl.className = 'info-card-img';
    imgEl.alt = 'Restaurant Image';
    imgEl.src = mapData.image;

    imageWrapper.appendChild(imgEl);
    infoWindowContent.appendChild(imageWrapper);
  }

  // Content section
  const contentWrapper = document.createElement('div');
  contentWrapper.className = 'info-card-content';

  const nameEl = document.createElement('h3');
  nameEl.className = 'info-card-name';
  nameEl.textContent = mapData.name || '';
  contentWrapper.appendChild(nameEl);

  const addressEl = document.createElement('p');
  addressEl.className = 'info-card-address';
  addressEl.textContent = mapData.location || '';
  contentWrapper.appendChild(addressEl);

  // Link to Google Maps (only if URL is valid)
  if (mapData.googleMapsLink) {
    const linkEl = document.createElement('a');
    linkEl.target = '_blank';
    linkEl.rel = 'noopener noreferrer';
    linkEl.className = 'info-card-link';
    linkEl.textContent = 'View on Google';

    try {
      // Use URL constructor to normalize and validate the link
      const linkUrl = new URL(mapData.googleMapsLink, window.location.origin);
      linkEl.href = linkUrl.href;
      contentWrapper.appendChild(linkEl);
    } catch (e) {
      // If the URL is invalid, do not set href or append the link
    }
  }

  infoWindowContent.appendChild(contentWrapper);
  const infoWindow = new google.maps.InfoWindow({
    content: infoWindowContent,
  });

  // const infoWindow = new google.maps.InfoWindow({
  //   content: `
  //       <div class="enquiry-map-info-card">
        
  //       ${mapData.image ? `<div class="info-card-image"><img src="${mapData.image}" alt="Restaurant Image" class="info-card-img"></div>` : ''}
        
  //       <div class="info-card-content">
  //           <h3 class="info-card-name"> ${mapData.name}</h3>
  //           <p class="info-card-address">${mapData.location}</p>
            
  //           <a href="${mapData.googleMapsLink}" 
  //           target="_blank" 
  //           rel="noopener noreferrer" 
  //           class="info-card-link">
  //               View on Google
  //           </a>
  //       </div>
  //   </div>`
  // });

  infoWindow.open(map, marker);

  marker.addListener('click', () => {
    infoWindow.open(map, marker);
  });

  map.addListener('click', () => {
    infoWindow.close();
  });
}